export var DOMAINS = {
  staging: {
    common: 'https://st-my.solarwinds.cloud',
    dashboards: 'https://st-my.solarwinds.cloud',
    pingdom: 'https://st-my.pingdom.com',
    appoptics: 'https://my-stg.appoptics.com',
    metrics: 'https://my-stg.appoptics.com',
    logs: 'https://app.gen3.qa.loggly.net'
  },
  production: {
    common: 'https://my.solarwinds.cloud',
    dashboards: 'https://my.solarwinds.cloud',
    pingdom: 'https://my.pingdom.com',
    appoptics: 'https://my.appoptics.com',
    metrics: 'https://my.appoptics.com',
    logs: 'https://app.loggly.com'
  }
};